<section class="auth-page">
  <app-animated-bg></app-animated-bg>
  <div class="auth-container">

    <!-- PIN unlock: this device has been authorized for PIN sign-in -->
    <div *ngIf="clientConfig && mode === 'pin'" class="auth-card pin-card">
      <div class="auth-logo">
        <img src="{{clientConfig.logoUrl}}" alt="{{clientConfig.name}}" draggable="false" />
      </div>
      <h1 class="auth-title">Enter your PIN</h1>
      <p class="auth-subtitle device-line">
        <span class="device-name">{{deviceAuth?.name}}</span>
        <span class="device-sep">&middot;</span>
        <span class="device-location">{{deviceAuth?.locationName}}</span>
      </p>
      <div *ngIf="notice" class="notice">{{notice}}</div>

      <div class="pin-dots" [class.shaking]="pinShaking" [class.validating]="pinValidating">
        <div *ngFor="let i of pinDots" class="dot" [class.filled]="i < pin.length"></div>
      </div>
      <div class="pin-error">{{pinError}}</div>

      <div class="pin-pad" [class.disabled]="pinValidating">
        <button type="button" *ngFor="let key of pinKeys" class="pin-key" (click)="pressDigit(key)">{{key}}</button>
        <div class="pin-key blank"></div>
        <button type="button" class="pin-key" (click)="pressDigit('0')">0</button>
        <button type="button" class="pin-key action" (click)="deleteDigit()" aria-label="Delete">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg"><path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"/><line x1="18" y1="9" x2="12" y2="15"/><line x1="12" y1="9" x2="18" y2="15"/></svg>
        </button>
      </div>

      <div class="form-actions center">
        <a (click)="usePassword()">Sign in with password instead</a>
      </div>
    </div>

    <div *ngIf="clientConfig && mode === 'password'" class="auth-card">
      <div class="auth-logo" (click)="resetClientConfig()">
        <img src="{{clientConfig.logoUrl}}" alt="{{clientConfig.name}}" draggable="false" />
      </div>
      <h1 class="auth-title">Sign In</h1>
      <div *ngIf="notice" class="notice">{{notice}}</div>
      <form [formGroup]="signInForm" (ngSubmit)="onSubmit()">
        <div class="input">
          <label for="email" class="hidden">Email or Phone</label>
          <input type="email" placeholder="Email or Phone" formControlName="email" autocomplete="username" required>
        </div>
        <div class="input">
          <label for="password" class="hidden">Password</label>
          <input type="password" placeholder="Password" formControlName="password" autocomplete="current-password" required>
        </div>
        <div class="error">{{error}}</div>
        <div class="form-actions right">
          <a *ngIf="deviceAuth" (click)="usePin()">Use PIN</a>
          <a [routerLink]="['/reset-password']">Reset Password</a>
          <button type="submit" class="button" [disabled]="loading">Sign In</button>
        </div>
      </form>
    </div>

    <div *ngIf="!clientConfig" class="auth-card">
      <h1 class="auth-title">Connect to Client</h1>
      <p class="auth-subtitle">Enter your client key to load your configuration.</p>
      <div class="input">
        <label class="hidden">Client Key</label>
        <input type="text" placeholder="Client Key" [(ngModel)]="configCode" />
      </div>
      <div class="form-actions right">
        <button class="button" (click)="requestClientConfig()">Request Client Config</button>
      </div>
    </div>

  </div>

  <div class="powered-by">
    powered by
    <a href="https://redfiretechnology.com/" target="_blank">
      <img src="assets/global/logo-red-fire.svg" alt="Red Fire Technology" draggable="false">
    </a>
  </div>
</section>
